import AuthDialog from "../auth/AuthDialog";
import { HealthyLife, StartFreeTrail } from "../discovery/LandingPage";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { createRazorPayTransaction, getRazorpayOrder } from "../../api/api";
import ic_tick from "../../assets/icons/ic_check.svg";
import ic_badge from "../../assets/icons/ic_badge_neonGreen.svg";
import { useAuthContext } from "../../context/AuthContext";
import PaymentSuccessDialog from "./PaymentSuccessDialog";
import CustomDialog from "../basic/Dialog";
import Loader from "../basic/Loader";
import { Dialog } from "@headlessui/react";
import Testimonials from "../discovery/Testimonials";
import { useNavigate } from "react-router-dom";

function PricingModel({ subscription, onSubscribe }) {
  return (
    <div
      className={`flex flex-col w-full px-10 py-8 font-open-sans bg-white bg-opacity-5 rounded-lg justify-center items-center ${
        subscription.bestValue
          ? "relative border-2 border-primary-neonGreen"
          : ""
      }`}
    >
      {subscription.bestValue && (
        <div
          className="absolute top-0 right-5 w-20 h-[80px] flex justify-center"
          style={{
            backgroundImage: `url(${ic_badge})`,
          }}
        >
          <p className="font-open-sans text-sm text-[#1A1B21] font-bold text-center mt-4">
            Best
            <br /> value
          </p>
        </div>
      )}
      <p className="text-white text-opacity-80 w-full">
        {subscription.duration} PLAN
      </p>
      <p className="flex flex-row mt-2 text-white text-opacity-80 items-end gap-5 w-full">
        <span className="text-white font-poppins text-4xl font-bold">
          {subscription.name}
        </span>
        {/* <span style={{textDecoration: 'line-through',color: 'red'}}>{subscription.previousAmount}</span>
        {subscription.amount} */}
      </p>
      <p className="flex flex-row mt-2 text-white font-poppins text-opacity-80 items-end gap-5 w-full">
        <span style={{ textDecoration: "line-through", color: "red" }}>
          {subscription.previousAmount}
        </span>
        {subscription.amount}
      </p>
      <div className="flex flex-1 flex-col mt-6 w-full">
        {subscription.details.map((detail, index) => {
          return (
            <p className="font-sans flex flex-row text-white leading-8 text-opacity-70">
              <span className="mr-2 mt-1">
                <img src={ic_tick} />
              </span>
              <span className="flex flex-1">{detail}</span>
            </p>
          );
        })}
      </div>
      <div
        className="max-w-max mt-14 flex py-4 text-[#000000] font-semibold text-base cursor-pointer rounded bg-primary-neonGreen px-5"
        onClick={() => {
          onSubscribe();
        }}
      >
        Get Started
      </div>
    </div>
  );
}

export default function PricingPage() {
  const navigate = useNavigate();
  const auth = useAuthContext();
  const [showPaymentSuccessDialog, setShowPaymentSuccessDialog] =
    useState(false);

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  });

  const displayRazorPay = async (subscriptionModel) => {
    window.location.href = "BillingBefore?plan=" + subscriptionModel.price;
    // if (!auth.state.user) {
    //   setShowAuth(true);
    //   return;
    // } else {
    //   try {
    //     const expiresAt = new Date(parseInt(auth.state.user.expiresAt));
    //     const isExpired = expiresAt < new Date();
    //     if (!isExpired && auth.state.user.trail === 0) {
    //       toast("You are already subscribed");
    //       return;
    //     }
    //   } catch (error) {}
    // }
    // setShowLoading(true);
    // const order = await getRazorpayOrder(subscriptionModel.price);
    // if (!order) {
    //   toast("Something went wrong, please try again");

    //   setShowLoading(false);
    //   return;
    // }
    // const expiry = new Date(
    //   new Date().getTime() + 86400000 * subscriptionModel.days
    // );
    // const options = {
    //   key: "rzp_live_0JqfhMT6OpmMvy",
    //   name: subscriptionModel.name,
    //   description: "Getactyv Subscription",
    //   order_id: order.id,
    //   handler: async function (response) {
    //     if (response.razorpay_payment_id && response.razorpay_signature) {
    //       const data = {
    //         plan_id: order.plan_id,
    //         paymentId: response.razorpay_payment_id,
    //         subscriptionId: order.id,
    //         created_at: order.created_at,
    //         expire_by: expiry.getTime(),
    //         planType: subscriptionModel.name,
    //         razorpay_signature: response.razorpay_signature,
    //         transactionAmount: subscriptionModel.price,
    //       };
    //       await createRazorPayTransaction(data);
    //       auth.updateUser();
    //       setSelectedPlan(subscriptionModel);
    //       setShowPaymentSuccessDialog(true);
    //       toast("Payment Successfull");
    //     } else {
    //       toast("Payment Failed");
    //     }
    //   },
    //   prefill: {
    //     name: auth.state.user.name,
    //     email: auth.state.user.email,
    //   },
    // };
    // const paymentObject = new window.Razorpay(options);
    // paymentObject.on("payment.failed", function (response) {
    //   toast("Payment Failed: " + response.error.description, { type: "error" });
    // });
    // setShowLoading(false);
    // paymentObject.open();
  };

  const subscriptionModels = [
    {
      duration: "MONTHLY",
      price: 249,
      days: 30,
      previousAmount: "₹399/month",
      amount: "₹249/month",
      name: "Basic Plan",
      details: [
        "Peronalized plans",
        "Access to the entire range of workout programs and games",
        "Personalized performance analytics",
        "Program recommendations based on difficulty level and desired goals",
        "Access to movement-led games",
        "Progress and program saving",
      ],
      bestValue: false,
    },
    {
      bestValue: true,
      duration: "YEARLY",
      price: 2499,
      days: 365,
      previousAmount: "₹4499/year",
      amount: "₹2499/year",
      name: "Even Better",
      details: [
        "Everything in Get Started plan, plus :",
        // "Peronalized plans",
        // "Access to the entire range of workout programs and games",
        // "Personalized performance analytics",
        // "Program recommendations based on difficulty level and desired goals",
        // "Access to movement-led games",
        // "Progress and program saving",
        "Upto 25 expert calls for assistance",
        "Performance-led and coach-led progress tracking",
        "Locked-in pricing (tax exclusive)",
      ],
    },
  ];
  const [selectedPlan, setSelectedPlan] = useState(subscriptionModels[0]);
  const [showLoading, setShowLoading] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  return (
    <div className="flex flex-col w-full h-full bg-primary-midBlack">
      <PaymentSuccessDialog
        show={showPaymentSuccessDialog}
        close={() => {}}
        subscription={selectedPlan}
      />
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <CustomDialog show={showLoading} close={() => {}}>
        <Dialog.Panel className={"p-10 "}>
          <Loader />
        </Dialog.Panel>
      </CustomDialog>
      <div className="w-full  py-10 px-5 md:px-20">
        <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
          <span className="text-primary-neonGreen">Select</span> Plan
        </p>
        <p className="font-open-sans mt-2 text-white text-opacity-80 text-base ">
          Heavy on good health. Light on pockets
        </p>
        {!auth.state.user ? (
          <div className="grid md:grid-cols-2 w-full py-10 px-5 md:px-10 rounded-lg my-10 bg-white bg-opacity-5">
            <div className="grid grid-rows-2 gap-5">
              <p className="text-white text-3xl font-bold font-poppins">
                Free Trial {"  "}
                <span className="text-sm font-normal opacity-70">
                  start your 30-day free trial
                </span>
              </p>
              <p className=" text-white text-sm font-normal font-poppins opacity-70">
                Everything in Get Started plan, free for 30 days
              </p>
            </div>
            <div className="flex items-center justify-end ">
              <button
                className="max-w-max mt-3 self-start text-white cursor-pointer text-sm rounded bg-primary-purple px-6 py-4"
                onClick={() => {
                  window.location.href =
                    "https://getactyv.com/newLogin?ref=wellnessFreeTrial_button";
                }}
              >
                Get. Actyv. Now.
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 my-10">
          {subscriptionModels.map((subscriptionModel) => {
            return (
              <PricingModel
                subscription={subscriptionModel}
                onSubscribe={() => {
                  displayRazorPay(subscriptionModel);
                  // navigate("/payment_Complete");
                }}
              />
            );
          })}
        </div>

        <Testimonials />
      </div>

      {!auth.state.user && (
        <HealthyLife
          openAuth={() => {
            setShowAuth(true);
          }}
        />
      )}
      {!auth.state.user && (
        <StartFreeTrail
          openAuth={() => {
            setShowAuth(true);
          }}
        />
      )}
    </div>
  );
}
